// SideMenu.jsx
import React from "react";
import { Menu } from "antd";
import "../TradeRoom/TradeRoom.css";
import "../DynamicSidebar/Side.css";

export default function SideMenu({
  items,
  activeKey,
  onClick,
  width = 90,
  id,
  className,
}) {
  return (
    <Menu
      mode="inline"
      id={id}
      className={className}
      style={{ borderInlineEnd: 0, background: "var(--bg-mn3)" }}
      items={items}
      selectedKeys={[activeKey]}
      onClick={onClick}
    />
  );
}
